<template>
  <div id="general">
    <!-- {{PlugJson}} -->
  </div>
</template>

<script>
export default {
  name: "general",
  props: {
    PlugJson: Object
  }
};
</script>

<style scoped>
</style>